<script>
  import constants from "@/constants";
  import * as css from "@/utils/css";
  export let link,
    appLink,
    vertical = false;
  const playStoreImg = "/assets/png/google-play-badge.png";
  const playStoreImg2x = "/assets/png/google-play-badge@2x.png";
  const appStoreImg = "/assets/png/app-store-badge.png";
  const appStoreImg2x = "/assets/png/app-store-badge@2x.png";
  const sizeClass = vertical ? "w-20xl my-xs" : "h-3xl lgb:h-xl";
  const { DEFAULT_SRC } = constants;

  import * as PropTypes from "prop-types";
  import { onMount } from "svelte";
  const { checkPropTypes, string, bool } = PropTypes;
  const propTypes = {
    link: string,
    vertical: bool,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "ShortVideoAppInstallBadges");
  });
</script>

<a class={`shrink-0 block ${sizeClass}`} href={link}>
  <div class={`relative ${vertical ? "w-full pb-[29.63%]" : "h-full"}`}>
    <img
      src={DEFAULT_SRC}
      data-src={playStoreImg}
      data-srcset={`${playStoreImg} 1x, ${playStoreImg2x} 2x`}
      alt="Google play store"
      class={`${vertical ? css.fullCover : "h-full w-auto"} lazyload`}
      width={189}
      height={56}
    />
  </div>
</a>
<a
  class={`shrink-0 block ${vertical ? "" : "ml-md"} ${sizeClass}`}
  href={appLink || link}
>
  <div class={`relative ${vertical ? "w-full pb-[33.33%]" : "h-full"}`}>
    <img
      src={DEFAULT_SRC}
      data-src={appStoreImg}
      data-srcset={`${appStoreImg} 1x, ${appStoreImg2x} 2x`}
      alt="App store"
      class={`${vertical ? css.fullCover : "h-full w-auto"} lazyload`}
      width={168}
      height={56}
    />
  </div>
</a>
